import styles from './stageUI.module.scss';

// Inline validation message rendered directly under a form field.
// Renders nothing when there is no error, so it is safe to drop under
// every field unconditionally. The plain `stage-field-error` class is a
// stable hook used by useStageValidation to scroll to the first error.
const FieldError = ({message}) => {
  if (!message) return null;
  return (
    <span className={`${styles['field-error']} stage-field-error`}>
      {message}
    </span>
  );
};

export default FieldError;
